"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MaterialEditorProvider = void 0;
var materia_editor_provider_1 = require("./materia-editor.provider");
Object.defineProperty(exports, "MaterialEditorProvider", { enumerable: true, get: function () { return materia_editor_provider_1.MaterialEditorProvider; } });
